export enum Roles {
    Restricted = -1,
    User = 0,
    SystemAdmin = 1,
    OrganizationAdmin = 2,    
}